import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import { Button } from '@mui/material'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import HistoryIcon from '@mui/icons-material/History'

import { useModalContext } from '../../../../ui/modal'
import { ConfirmSendDialog } from '../dialogs'
import { useJobsContext } from '../../contexts'

export const TableActions = ({ cell }) => {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  const { executeBatch } = useJobsContext()
  const {
    actions: { open },
  } = useModalContext()

  const jobId = cell?.row.original.id

  const handleHistoryClick = useCallback(() => {
    if (jobId) {
      navigate(`historic/?batch_id=${jobId}`)
    }
  }, [navigate, jobId])

  if (!cell) {
    return null
  }

  const rowData = cell.row.original

  const handleOpenModal = () => {
    open({
      Component: ConfirmSendDialog,
      data: { batch: rowData, executeFunction: executeBatch, navigate },
    })
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'right', gap: '5px' }}>
      <Button
        variant="outlined"
        size="small"
        onClick={handleOpenModal}
        startIcon={<PlayArrowIcon />}
      >
        {formatMessage({ id: 'pages.jobs.table.actions.run' })}
      </Button>
      <Button
        variant="outlined"
        size="small"
        onClick={handleHistoryClick}
        startIcon={<HistoryIcon />}
      >
        {formatMessage({ id: 'pages.jobs.table.actions.history' })}
      </Button>
    </div>
  )
}
